import React, { useCallback, useEffect, useRef } from "react";
import { Image as Img } from "react-konva";

interface ImageProps {
  image: any;
  name?: string;
  width?: number;
  height?: number;
  filters?: any[];
  contrast?: number;
  brightness?: number;
}

const Image: React.FC<ImageProps> = ({
  image,
  name,
  width,
  height,
  filters,
  contrast,
  brightness,
}) => {
  const imageRef = useRef<any>(null);

  useEffect(() => {
    if (image) {
      // you many need to reapply cache on some props changes like shadow, stroke, etc.
      applyCache();
    }
  }, [image]);

  const applyCache = useCallback(() => {
    imageRef.current.cache();
  }, []);

  return (
    <Img
      ref={imageRef}
      name={name}
      width={width}
      height={height}
      image={image}
      filters={filters}
      contrast={contrast}
      brightness={brightness}
    />
  );
};

export default Image;
